export default __webpack_public_path__ + "static/media/post-animation.22ea8916.svg";